import axios from "../BASE_API";
import AuthHeader from "../AuthHeader";

export class DiseaseInsectAPI {

  allDiseaseInsect: any = (data: any) => {
    return axios.post("/disease-and-insect/list", data, { headers: AuthHeader() });
  };

  diseaseInsectActiveList: any = () => {
    return axios.get("/disease-and-insect/activeList", { headers: AuthHeader() });
  };

  createNewDiseaseInsect: any = (data: any) => {
    return axios.post("/disease-and-insect/add", data, { headers: AuthHeader() });
  };

  changeDiseaseInsectStatusById: any = (id: number) => {
    return axios.put(
      "/disease-and-insect/changeStatus",
      { id: id },
      { headers: AuthHeader() }
    );
  };

  deleteDiseaseInsect: any = (id: number) => {
    return axios.delete("/disease-and-insect/delete", {
      data: { id: id },
      headers: AuthHeader(),
    });
  };

  getDiseaseInsectById: any = (id: number) => {
    return axios.get(`/disease-and-insect/details/${id}`, { headers: AuthHeader() });
  };

  updateDiseaseInsect: any = (data: any) => {
    return axios.put("/disease-and-insect/update", data, {
      headers: AuthHeader(),
    });
  };

  
}
